// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__II_ov","dragIcon":"Choice_dragIcon__2m0vB","left":"Choice_left__qm245","input":"Choice_input__2qVPc"};